import JuHui from 'branchComponent/modal/JuHui/JuHui';
import JuHui2 from 'branchComponent/modal/JuHui/JuHui2';
import PLANREFUND from 'branchComponent/modal/PLANREFUND';
import VICUSTOMDENY from 'branchComponent/modal/VICUSTOMDENY';
import PROVREFUND from 'branchComponent/modal/PROVREFUND';
import JflowProcess from 'branchComponent/modal/JflowProcess.vue';
import SendRedirect from 'branchComponent/modal/SendRedirect.vue';
import SendEmail from 'branchComponent/modal/SendEmail';
import JflowTranspond from 'branchComponent/modal/JflowTranspond';
import JflowRestitution from 'branchComponent/modal/JflowRestitution';
import ResetOA from 'branchComponent/modal/ResetOA';
import StoreCloseAgree from 'branchComponent/modal/StoreCloseAgree';
import FormExcelUpload from 'branchComponent/modal/FormExcelUpload';
import SubIframe from 'branchComponent/modal/SubIframe';
import CustomerSelect from 'branchComponent/modal/CustomerSelect';
export default {
  JuHui: {
    component: JuHui,
  },
  JuHui2: {
    component: JuHui2,
  },
  PLANREFUND: {
    component: PLANREFUND
  },
  PROVREFUND: {
    component: PROVREFUND
  },
  VICUSTOMDENY: {
    component: VICUSTOMDENY
  },
  JflowProcess: {
    component: JflowProcess
  },
  SendRedirect: {
    component: SendRedirect
  },
  SendEmail: {
    component: SendEmail
  },
  JflowTranspond: {
    component: JflowTranspond
  },
  JflowRestitution: {
    component: JflowRestitution
  },
  ResetOA: {
    component: ResetOA
  },
  StoreCloseAgree: {
    component: StoreCloseAgree
  },
  FormExcelUpload: {
    component: FormExcelUpload
  },
  SubIframe: {
    component: SubIframe
  },
  CustomerSelect: {
    component: CustomerSelect
  }
};